/******************************************************
 *                  Confirm directive
 *
 * This directive asks user to confirm his choice.
 * 
 ********************************************************/
 
"use strict";
 
angular.module("app")
	.directive("confirm", function () {
		return {
			priority: 100,
			restrict: "A",
			link: {
				pre: function (scope, element, attrs) {
					var msg = attrs.confirm || "Etes-vous sur ?";

					element.bind("click", function (event) {
						if (!confirm(msg)) {
							event.stopImmediatePropagation();
							event.preventDefault;
						}
					});
				}
			}
		};
	});
